import { render, staticRenderFns } from "./PopupViolationCriteria.vue?vue&type=template&id=2bd5ecc2&scoped=true"
import script from "./PopupViolationCriteria.vue?vue&type=script&lang=js"
export * from "./PopupViolationCriteria.vue?vue&type=script&lang=js"
import style0 from "./PopupViolationCriteria.vue?vue&type=style&index=0&id=2bd5ecc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5ecc2",
  null
  
)

export default component.exports